var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgEdit03Icon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 20H21M3.00002 20H4.67457C5.16375 20 5.40834 20 5.63851 19.9447C5.84259 19.8957 6.03767 19.8149 6.21662 19.7053C6.41845 19.5816 6.5914 19.4086 6.93731 19.0627L19.5 6.49999C20.3285 5.67156 20.3285 4.32842 19.5 3.49999C18.6716 2.67156 17.3285 2.67156 16.5 3.49999L3.93728 16.0627C3.59138 16.4086 3.41843 16.5816 3.29474 16.7834C3.18509 16.9624 3.10428 17.1575 3.05528 17.3615C3.00002 17.5917 3.00002 17.8363 3.00002 18.3255V20Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit03Icon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;